




export const journey_options = [
  "family",
  "homecare",
  // "nursing"
]



export const family_subjourney_options = [
  "away",
  "with",
]






export const section_options = [
  "basics",
  "features",
  "pricing",
  "security",
  "faqs",
]

